import { Routes, Route, useSearchParams, useParams } from "react-router-dom";
import PropTypes from "prop-types";
import PreChatSurveyForm from "../components/pre-chat/SurveyForm.jsx";
import PostChatSurveyForm from "../components/post-chat/SurveyForm.jsx";
import PreSmsSurveyForm from "../components/pre-sms/SurveyForm.jsx";
import SessionInvalidPage from "../components/post-chat/SessionInvalidPage.jsx";
import ThankYouPage from "../components/post-chat/ThankYouPage.jsx";
import TriagePage from "../components/post-chat/TriagePage.jsx";

const isPreSmsSurveyEnabled =
  import.meta.env.VITE_FEATURE_PRE_SMS_SURVEY === "true";

const PreSmsSurveyFormWrapper = ({ filteredParams }) => {
  const { interactionId } = useParams();
  return (
    <PreSmsSurveyForm
      interactionIdKey={interactionId}
      filteredParams={filteredParams}
    />
  );
};

PreSmsSurveyFormWrapper.propTypes = {
  filteredParams: PropTypes.object,
};

const FormRouter = ({ modality, interactionIdKey, filteredParams }) => {
  const [searchParams] = useSearchParams();
  const lang = searchParams.get("lang");
  const query = lang === "es" ? "?lang=es" : "";

  return (
    <Routes>
      {/* Pre-chat Home route */}
      {modality === "web" && (
        <Route
          path="/"
          element={
            <PreChatSurveyForm
              interactionIdKey={interactionIdKey}
              filteredParams={filteredParams}
            />
          }
        />
      )}
      {/* Pre-sms route with interaction ID */}
      {isPreSmsSurveyEnabled && modality === "sms" && (
        <Route
          path="/:interactionId"
          element={<PreSmsSurveyFormWrapper filteredParams={filteredParams} />}
        />
      )}

      {/* Post-chat or text with session ID */}
      <Route
        path="/feedback/:chatId"
        element={
          <PostChatSurveyForm
            modality={modality}
            interactionIdKey={interactionIdKey}
            filteredParams={filteredParams}
            lang={lang}
          />
        }
      />

      <Route
        path="/feedback/:chatId/thank-you"
        element={<ThankYouPage query={query} />}
      />
      <Route
        path="/feedback/:chatId/follow-up"
        element={<TriagePage query={query} />}
      />

      {/* Invalid page: Eg.: Feedback without chatId - redirect to SessionInvalidPage */}
      <Route path="*" element={<SessionInvalidPage />} />
    </Routes>
  );
};

FormRouter.propTypes = {
  modality: PropTypes.string,
  interactionIdKey: PropTypes.string,
  filteredParams: PropTypes.shape({
    surveyID: PropTypes.string,
  }),
};

export default FormRouter;
